module.exports = __webpack_public_path__ + "static/forecast/weather/daypartcloud-bcc1712d23a36ad572cad9758b081f93.svg";